<template>
  <div :class="classes">
    <pt-page-title v-if="!isDialog && !isLot" title="委托单" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="filterForm.searchKey">
      <div slot="left">

        <pt-page-menu-filter :tabs="tabs" :isRouteQuery="false" v-model="selectTab" :class="$style.menufilter"></pt-page-menu-filter>
      </div>
    </pt-page-title>
    <el-button v-if="!isDialog && !isLot" type="primary" @click="goCreated">新建委托单</el-button>
    <pt-page-factor-filter v-if="!isDialog" :labels="filterLabels" labelWidth="100px" :displayVertical="true" v-model="filterForm" ref="filter">
      <template slot="organizationId">
        <organization-selector v-model="filterForm.organizationId" :filterable="true"></organization-selector>
      </template>
      <div :class="$style['buttons']">
        <div>
          <el-button type="primary" @click="handleFilter()">筛选</el-button>
          <template v-if="!isLot">
            <el-button type="primary" @click="download()" :loading="downloadLoading">下载委托书</el-button>
            <el-button type="primary" @click="download(null,'report')" :loading="downloadReportLoading">下载报告</el-button>
            <el-button type="primary" @click="exportExcel" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportExcel(true)" :loading="exportLoading">全部导出</el-button>
            <el-button type="primary" @click="downloadHistory">委托书下载历史</el-button>
            <el-button type="primary" @click="downloadHistoryOfReport">报告下载历史</el-button>
            <el-button type="primary" @click="exportHistory">导出历史</el-button>
            <el-button type="primary" @click="importHistory">导入历史</el-button>
          </template>
          <el-button v-else type="text" @click="toggleFilter">{{expandFilter ? '收起' :'展开'}}筛选条件</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </div>
        <div v-if="!isLot" class="right-operate-buttons">
          <el-button type="primary" :class="$style['button__box']" @click="handleDelete" :loading="deleteLoading">删除</el-button>
          <el-button type="primary" :class="$style['button__box']" @click="handleSettle" :loading="settleLoading" :disabled="!HAS_PERM_SETTLEMENT">结算</el-button>
          <el-button type="primary" :class="$style['button__box']" @click="handleInvoice" :loading="invoiceLoading" :disabled="!HAS_PERM_INVOICE">开票</el-button>
          <el-button type="primary" :class="$style['button__box']" @click="dialogVisible = true">批量操作</el-button>
        </div>
      </div>
    </pt-page-factor-filter>
    <div v-if="isDialog && !isLot" style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
      <el-input style="margin-right:10px;" placeholder="请输入关键字搜索" v-model="filterForm.searchKey" :clearable="true">
      </el-input>
      <el-button type="primary" @click="search(filterForm.searchKey)">搜索</el-button>
    </div>
    <!-- table -->
    <pt-trust-deed-table ref="table" :isDialog="isDialog" :tableLabels="tableLabels" :selectType="selectType" :selectedKeys="selectedKeys" @selection-change="updateSelectedData" :billStatusEnum="billStatusEnum" :params="params" @getAllSize="getAllSize" :isLot="isLot">
      <template slot="reportNum" slot-scope="scope">
        {{scope.row.reportNum }}
         <el-tag v-if="scope.row.mandateStamped" type="danger" size="small">{{ scope.row.mandateStamped_text }}</el-tag>
      </template>
      <template slot="billStatusEnum" slot-scope="scope">
        {{scope.row.billStatusEnum_text}}
        <el-tag v-if="scope.row.urgent" type="danger" size="small">加急</el-tag>
        <el-tag v-if="scope.row.overDue" type="warning" size="small">逾期</el-tag>
        <el-tag v-if="scope.row.isDelay" type="warning" size="small" style="margin-left: 5px;">已延期</el-tag>
      </template>

        <div slot-scope="scope" :class="$style['operate-buttons']">
        <el-button type="text" size="small" @click.stop="goDetail(scope.row.id)">详情
        </el-button>
          <el-button type="text" size="small" @click.stop="copyBills(scope.row.id)" :loading="copyLoading">复制
          </el-button>
        <el-button v-if="!isLot && !isDialog" type="text" @click.stop="download(scope.row.id)" size="small">下载委托书
        </el-button>
        <el-button type="text" size="small" v-if="isCanDownloadReport(scope.row)" @click="download(scope.row.id, 'report')">下载报告</el-button>
        <!-- <el-button
          type="text"
          @click.stop="goEdit(scope.row.orderId, scope.row)"
          v-if="HAS_PERM_LAB_EDIT_ORDER && scope.row.orderStatusEnum !== 'CLOSED'"
          >编辑
        </el-button> -->
        </div>
    </pt-trust-deed-table>
    <trustDeedInvoiceDialog :dialogVisible="showDialog" @close="showDialog = false" :selectData="selectData" @reload="reload"></trustDeedInvoiceDialog>
    <!-- 批量操作选择的dialog -->
    <pt-lot-operate-choice-dialog :dialogVisible="dialogVisible" :handle-close="()=>dialogVisible = false"></pt-lot-operate-choice-dialog>
  </div>
</template>

<script>
import fillUrl from '@/mixins/fillUrl'
import ptPageTitle from 'cps/base/pt-page-title'
import organizationSelector from 'cps/selector/organization-selector.vue'
import ptTrustDeedTable from './pt-trust-deed-table/withData.vue'
import trustDeedInvoiceDialog from 'cps/common/trust-deed-invoice-dialog'
import ptLotOperateChoiceDialog from '../pt-lot-operate-choice-dialog'

import { tabs, filterLabels, tableLabels } from './options'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'

// 组件class前缀
const prefixCls = 'pt-trust-deed-list'

export default {
  name: 'pt-trust-deed-list',
  mixins: [fillUrl],
  components: {
    ptPageTitle,
    ptTrustDeedTable,
    organizationSelector,
    trustDeedInvoiceDialog,
    ptLotOperateChoiceDialog
  },
  props: {
    selectType: {
      type: String,
      default: 'checkbox'
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: String,
      default: ''
    },
    billStatusEnum:{
      type:String,
      default:null
    },
    exportLoading: Boolean,
    downloadLoading: Boolean,
    downloadReportLoading: Boolean,
    isLot: Boolean,
    deleteLoading:Boolean
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_PERM_INVOICE () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_07')
      return M_PERM || SETTLEMENT_PERM
    },
    HAS_PERM_SETTLEMENT () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_06')
      return M_PERM || SETTLEMENT_PERM
    }
  },
  data () {
    return {
      selectTab: 'ALL',
      tabs,
      tableLabels,
      expandFilter: false,
      filterLabels: this.isLot ? filterLabels.filter(e=>e.value !== 'billStatusEnum').slice(0, 4) : filterLabels,
      searchKey: '',
      filterForm: {
        searchKey: ''
      },
      loading: false,
      settleLoading: false,
      isFuzzy: false,
      selectData: [],
      params: {},
      showDialog: false,
      invoiceLoading: false,
      dialogVisible: false,
      copyLoading: false
    }
  },
  watch: {
    selectTab (val, old) {
      if (val !== old) {
        const params = { ...this.filterForm }
        params.billStatusEnum = val === 'ALL' ? null : val
        this.$refs.table.filter(params)
      }
    }
  },
  methods: {
    isCanDownloadReport (row) {
      return row.executeWordUrl
    },
    getAllSize(val){
      this.$emit('getAllSize', val)
    },
    toggleFilter () {
      this.expandFilter = !this.expandFilter
      this.filterLabels = this.expandFilter ? filterLabels : filterLabels.slice(0, 4)
    },
    search (val) {
      if (val) {
        this.filterForm.searchKey = val
      } else {
        this.filterForm.searchKey = null
      }
      this.handleFilter()
    },
    emptySearch () {
      this.handleFilter()
    },
    goCreated () {
      this.$router.push('/business-order-lot-new')
    },
    updateSelectedData (data) {
      if (this.isDialog || this.isLot) {
        this.$emit('selection-change', data)
      } else {
        this.selectData = data
      }
    },
    exportHistory () {
      this.$router.push('/export-history/bills?name=lab_bill_export')
    },
    importHistory () {
      this.$router.push('/export-history/bills?name=billbatch&isImport=true&batchNumber=bill')
    },
    downloadHistory () {
      this.$router.push('/export-history/bills_download?name=lab_bill_pdf_download&isDownload=true')
    },
    downloadHistoryOfReport () {
      this.$router.push('/export-history/bills_download_report?name=lab_bill_word_download&isDownload=true')
    },
    handleFilter () {
      this.$refs.table?.filter(this.filterForm)
    },
    download (id,downloadType) {
      let data = {}
      if (!this.selectData.length&&!id) {
        this.$message.error('请至少选择一条记录')
        return
      }
      if (this.selectData) {
        this.params.ids = id?[id]:this.selectData.map(e => e.id)
        data = this.params
      }

      this.$confirm('下载操作需要花费一定时间，完成下载后我们会将数据保存在“下载历史”中，您稍后下载即可。', '下载提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('billsExportPdf', data, downloadType)
      })
    },
    exportExcel (isAll) {
      let data = {}
      if (isAll === true) {
        data = {}
      } else {
        if (!this.selectData.length) {
          this.$message.error('请至少选择一条记录')
          return
        }
        if (this.selectData) {
          this.params.ids = this.selectData.map(e => e.id)
          data = this.params
        }
      }
      this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('billsExportExcel', data)
      })
      // this.selectData = []
    },
    cleanParams () {
      emptyObject(this.filterForm)
      this.handleFilter()
    },
    reload () {
      this.$refs.table.reload()
    },
    handleSettle () {
      if (!this.selectData.length) {
        this.$message.warning('请先勾选委托单')
        return
      }
      if (this.selectData.some(e => e.settlement)) {
        this.$message.warning('您勾选的订单中包含已结算的委托单，请重新选择')
        return
      }
      this.$confirm(`该委托单是否“确认已结算”?`, '确认已结算', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.settleLoading = true
        let data = {
          ids: this.selectData.map(e => e.id)
        }
        this.$store.dispatch('handleSettle', data).then(res => {
          this.settleLoading = false
          this.$message.success('操作成功')
          this.reload()
        }).catch(err => {
          this.settleLoading = false
          this.$message.warning(err || '操作失败')
        })
      })
    },
    handleDelete () {
      if (!this.selectData.length) {
        this.$message.warning('请先选择一个委托单')
        return
      }
      this.$confirm(`请确认是否删除这些委托单，删除后将不可恢复，请确认`, '确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        let ids=this.selectData.map(item=>item.id)
        this.$emit('deleteBills', ids)
      })
    },
    handleInvoice () {
      if (!this.selectData.length) {
        this.$message.warning('请先选择一个委托单')
        return
      }
      if (this.selectData.length > 1) {
        this.$message.warning('只能选择一个委托单开票')
        return
      }
      if (this.selectData.some(e => e.invoice)) {
        this.$message.warning('您勾选的订单中包含已开票的委托单，请重新选择')
        return
      }
      this.showDialog = true
    },
    goDetail (id) {
      this.$router.push(`/trust-deed-detail/${id}`)
    },
    copyBills (id) {
      this.$confirm(`请确认是否复制该委托单，请确认`, '确认复制', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.copyLoading = true
        this.$store.dispatch('copyBills', id).then(res => {
          this.copyLoading = false
          this.$message.success('复制成功')
          this.$refs.table.reload()
        }).catch(err => {
          this.copyLoading = false
          this.$message.warning(err || '复制失败')
        })
      })
    }
  },
  created () {
    if (!this.isDialog) {
      this.filterForm = this.getObjectFromRoute()
      this.params = this.getObjectFromRoute()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.buttons {
  display: flex;
  width: 100%;
  justify-content: space-between;
  :global{
    .right-operate-buttons{
      display: flex;
      justify-content: flex-end;
    }
  .el-button{
    margin-right: 8px;
    padding: 10px;
    margin-left: 0!important;
  }
  }
}
.button__box {
  // min-width: 100px;
  > big {
    font-size: 18px;
    font-weight: bold;
  }
}
.menufilter {
  // width: 10rem;
  // position: absolute;
  // top: 0;
  // left: 55%;
  // transform: translateX(-50%);
}
.operate-buttons{
  :global{
    .el-button + .el-button{
      margin-left: 5px;
    }
  }
}
</style>
